import React from "react";
import { Button, Form, Table } from "react-bootstrap";
import './budgetremittancestab.css'

const Budgetremittancestab: React.FC = () => {
    return (
        <>
            <div className="common_card mby_20">
                <div className="top top_bar_flx border_tittle mby_16">
                    <div className="top_bar_tittle">
                        <h2 className="mb-2">Remittances (835/RA)</h2>
                        <p>Auto‑pull is ON. We poll your Medicaid SFTP/API daily for new 835 files. You can also attach files manually as a fallback.</p>
                    </div>
                    <div className="top_right_flx flex-wrap">
                        <Form.Check
                            type="switch"
                            id="custom-switch"
                            label="Check this switch"
                            className='my_toggle mb-0'
                        />
                        <Button variant="light" className="btn_sm">Fetch Now</Button>
                    </div>
                </div>
                <Form.Group controlId="formFile" className="custom_input_flled">
                    <Form.Control type="file" />
                </Form.Group>
                <div className="gemittances_card_grid mby_16">
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Unapplied</p>
                            <h3>$3,420</h3>
                        </div>
                    </div>
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Partial Matches</p>
                            <h3>7</h3>
                        </div>
                    </div>
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Ready to Post</p>
                            <h3>24</h3>
                        </div>
                    </div>
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Overpayments / Recoups</p>
                            <h3>$620</h3>
                        </div>
                    </div>
                </div>
                <div className="form_btn_flx justify-content-start">
                    <Button variant="primary" className="btn_sm">Reconcile</Button>
                    <Button variant="light" className="btn_sm">Post Payments</Button>
                </div>
            </div>
            <div className="common_card mby_16">
                <div className="top top_bar_flx border_tittle mby_16">
                    <div className="top_bar_tittle">
                        <h2>Notes for this RA submission (optional)</h2>
                    </div>
                </div>
                <Form.Group controlId="formExampleText" className="custom_input_flled mb-0">
                    <Form.Control type="text" placeholder="eg.. Weekly Medicaid RA from 09/08 "
                    />
                </Form.Group>
            </div>
            <div className="common_card mby_16">
                <div className="top top_bar_flx mby_16">
                    <div className="top_bar_tittle">
                        <h2>Rates & Effective Dating</h2>
                    </div>
                </div>
                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Modifier</th>
                            <th>Region</th>
                            <th>Rate</th>
                            <th>Effective From</th>
                            <th>Effective To</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>T1016</td>
                            <td>-</td>
                            <td>All</td>
                            <td>${"{r.rate.toFixed(2)}"}</td>
                            <td>2025-01-01</td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <td>T1016</td>
                            <td>U1</td>
                            <td>Region 7</td>
                            <td>${"{r.rate.toFixed(2)}"}</td>
                            <td>2025-01-01</td>
                            <td>-</td>
                        </tr>
                    </tbody>
                </Table>

            </div>
        </>
    );
};

export default Budgetremittancestab;
